import
  React, {
  useContext,
  useEffect,
  useState
}	from 'react';

import {
  useHistory,
  useLocation
} from 'react-router-dom';

import {
  HContainer,
  JourneyProvider,
  PillBar,
  Text,
  VFillContainer
} from '@vodacom/web-common';

import {
  Environment
} from '@vodacom/web-env';

import {
  HandleOtp,
  HandleRender,
  withScreenViewTagging
} from 'hocs';

import {
  BackButton,
  Hero
} from 'components';

import {
  getAuthToken,
  getStorageWithExpiry,
  handleUtagLinkEvent,
  isEqual,
  printCurrency
} from 'helpers';

import {
  DrupalProvider
} from 'providers';

import {
  CacheKeys,
  CustomColors,
  ErrorKeys,
  OtpType,
  VoucherDashboardViews
} from '../../../../constants';

import {
  BannerCard,
  ItemSelector,
  PastPurchases,
  VendorCard
} from '../components';

import {
  CatalogueProvider
} from '../providers';

import {
  AdvanceProvider
} from 'journeys';

import {
  AppContext
} from 'context';

const VoucherAdvanceLandingUI = () => {

  const location = useLocation();
  const { config } = useContext(AppContext);

  const [ state, setState ] = useState({
    isLoading: false,
    isError: false,
    content: null,
    item: location.state?.item || null,
    loadContent: !!getAuthToken()
  });

  const [ showBanner, setShowBanner ] = useState(true);

  const [ pills, setPills ] = useState({
    list: VoucherDashboardViews,
    activePill: VoucherDashboardViews[0].value,
    error: null
  });

  const [ categories, setCategories ] = useState({
    loading: true,
    data: null,
    error: null,
    activeCategory: JourneyProvider.get('Catalogue', 'activeCategory')
  });

  const [ eligibility, setEligibility ] = useState(null);

  const getEligibility = async () => {

    const eligibilityResponse = await AdvanceProvider.getCachedItem(
      CacheKeys.VoucherAdvanceEligibility,
      null,
      AdvanceProvider.getEligibility
    );

    if (!eligibilityResponse?.ok || !eligibilityResponse?.result) {

      setEligibility(prevState => ({
        ...prevState,
        eligibility: false
      }));

      return;
    }

    setEligibility(eligibilityResponse.result);
  };

  const history = useHistory();

  VoucherAdvanceLandingUI.tagViewData = {
    event_name:'page_view,category_view',
    page_section: 'voucher advance',
    visitor_customer_segment: getStorageWithExpiry('msisdn', 'msisdnType', ''),
    visitor_type: 'consumer',
    visitor_id_asset_active: getStorageWithExpiry('msisdn', 'hashedMsisdn', ''),
    voucher_advance_category: categories.activeCategory
  };

  const getCachedData = async () => {

    setState(prevState => ({
      ...prevState,
      isLoading: true
    }));

    const cachedItem = await DrupalProvider.getCachedItem(
      `${CacheKeys.Pillars}buy`,
      null,
      () => DrupalProvider.getPillarTiles('buy')
    );

    if (cachedItem && cachedItem.ok && cachedItem.result) {

      const voucherAdvanceItem =
        cachedItem?.result?.find(
          item => isEqual(item?.title, 'Vouchers')
        );

      setState(prevState => ({
        ...prevState,
        item: voucherAdvanceItem,
        isLoading: false
      }));
    }
  };

  useEffect(() => {

    if (!state.loadContent) {
      return;
    }

    if (eligibility === null) {

      getEligibility();
    }
  }, [ state.loadContent ]);

  useEffect(() => {

    if (!state.loadContent) {
      return;
    }

    const init = async () => {

      if (!state.item) {
        await getCachedData();
      }

      if (pills.activePill === VoucherDashboardViews[1].value) {
        return;
      }

      await getCategoryList();
    };

    init();
  }, [ pills.activePill, state.loadContent ]);

  const HeroBanner = () => {

    const voucherAdvanceConfig = config?.voucherAdvanceConfig;
    const description = eligibility?.eligibility ? voucherAdvanceConfig?.eligibleDescription : voucherAdvanceConfig?.ineligibleDescription;

    return (

    <Hero
      background={`${Environment.current.drupalBaseUrl}${state.item?.image}`}
      subtitle={description}
      subtitleFontSize={'16px'}
      subtitleFontWieght={'inherit'}
      titlePadding={'0'} />
    );
  };

  const Banner = () => {

    const bannerText = (eligibility?.eligibility && eligibility?.maxEligibleAmount) ?
      `You have a <b>${printCurrency(eligibility?.maxEligibleAmount)} advance available</b>.` :
      config?.voucherAdvanceConfig?.buyNowBanner;

    return (

      <>
        <BannerCard
          text={bannerText}
          onClick={() => {
            history.push({
              pathname: `/pillars/buy/${state.item?.id}`,
              state: {
                item: state.item
              }
            });
          }}
          onClose={() => setShowBanner(false)}/>
      </>
    );
  };

  const getCategoryList = async () => {

    setCategories(prevState => ({
      ...prevState,
      loading: true
    }));

    const response = await CatalogueProvider.getCachedItem(
      CacheKeys.VoucherAdvanceCategories,
      null,
      CatalogueProvider.listCategory
    );

    if (!response?.ok || !response?.result) {

      setCategories(prevState => ({
        ...prevState,
        loading: false,
        error: response?.error
      }));

      return;
    }

    setCategories(prevState => ({
      ...prevState,
      loading: false,
      data: response.result,
      activeCategory: prevState.activeCategory || buildSelectorList(response.result)?.[0]?.value
    }));
  };

  const buildSelectorList = (categoryList) => {

    if (!Array.isArray(categoryList) || !categoryList?.length) {
      return;
    }

    let list = [];

    for (const category of categoryList) {

      if (!category) {
        continue;
      }

      list.push({
        value: category.name,
        label: category.name,
        iconUrl: category.attachment?.url
      });
    }

    return list;
  };

  const VendorCardList = (props) => {

    let list = [];

    const vendors = props.categoryList?.find(category => category?.name === props.activeCategory)?.vendors;

    if (!Array.isArray(vendors) || !vendors?.length) {

      return (

        <Text
          key={'no-outlets-available'}
          fontSize={'18px'}
          fontWeight={'bold'}
          padding={'16px 0'}
          color={CustomColors.Grey9}
          dangerouslySetInnerHTML={{ __html: config?.voucherAdvanceConfig?.outletsUnavailableError }}/>

      );
    }

    list.push(

      <Text
        key={'vendor-list-header-text'}
        fontSize={'18px'}
        fontWeight={'bold'}
        padding={'16px 0 8px'}
        color={CustomColors.Grey9}>

        {'Select your favourite outlet'}
      </Text>
    );

    const onVendorCardClick = vendorId => {

      history.push({
        pathname: `/voucher-advance/${vendorId}`,
        state: {
          item: state.item
        }
      });
    };

    for (const vendor of vendors) {

      if (!vendor) {
        continue;
      }

      list.push(

        <VendorCard
          key={`vendor-card-${vendor.name}`}
          vendorId={vendor.id}
          onClick={() => onVendorCardClick(vendor.id)}/>
      );
    }

    return list;
  };

  const Vouchers = () => {

    return (

        <HandleRender
          isLoading={categories.loading}
          isError={categories.error}
          error={{
            type: ErrorKeys.General
          }}>

          <ItemSelector
            onChange={value => {

            setCategories(prevState => ({
              ...prevState,
              activeCategory: value
            }));

            handleUtagLinkEvent({
              event_name: 'category_view',
              voucher_advance_category: value
            });

            JourneyProvider.set('Catalogue', { activeCategory: value });
          }}
          items={buildSelectorList(categories.data)}
          defaultItem={JourneyProvider.get('Catalogue', 'activeCategory') || buildSelectorList(categories.data)?.[0]?.value}/>

        <VendorCardList
          categoryList={categories.data}
          activeCategory={categories.activeCategory}/>
      </HandleRender>
    );
  };

  const PillBarComponent = () => {

    const onPillClicked = (selectedPill) => {

      setPills(prevState => ({
        ...prevState,
        activePill: selectedPill.value
      }));
    };

    return (
      <>
        <HContainer
          border={`1px solid ${CustomColors.Grey5}`}
          borderRadius={'4px'}
          margin={'25px 0'}
          overflow={'hidden'}>

          <PillBar
            onPillClicked={onPillClicked}
            pills={pills.list}
            defaultPill={pills.activePill}
            pillBorder={'none'}
            pillBorderRadius={'4px'}
            pillBarBackgroundColor={CustomColors.White}
            pillMargin={'0'}
            inActiveFontColor={CustomColors.Grey8}
            activeColor={CustomColors.Grey9}
            textPadding={'9px 0'}
            fontSize={'16px'}
            fontFamily={'Roboto'} />
        </HContainer>

          {
            isEqual(pills.activePill, VoucherDashboardViews[0].value)
              ? <Vouchers/>
              : isEqual(pills.activePill, VoucherDashboardViews[1].value)
                ? <PastPurchases/>
                : <></>
          }
      </>
    );
  };

  const Content = () => {

    return (

      <HandleRender
        isLoading={state.isLoading}
        isError={state.isError}
        error={{
          type: ErrorKeys.Technical
        }}
        loader={{ size: '100' }}>

        <>

          { showBanner &&
            <Banner/>
          }

          { state.item &&
            <HeroBanner/>
          }

          <VFillContainer
            padding={'0 20px 35px'}>

            <BackButton
              onClick={() => history.push('/pillars/buy')}
              margin={'8px 0 0'}/>

            <PillBarComponent/>

          </VFillContainer>
        </>

      </HandleRender>
    );
  };

  const requestOtp = response => {

    if (!response?.ok || !response?.result || !response?.result?.successful) {

      setState(prevState => ({
        ...prevState,
        isLoading: false,
        isError: true
      }));

      return;
    }
  };

  const resendOtp = () => {

    handleUtagLinkEvent({
      event_name: 'campaign_internal_click',
      link_id: 'cbu: connectu: voucher advance: resend otp'
    });
  };

  const verifyOtp = response => {

    if (response?.ok && response?.result) {

      setState(prevState => ({
        ...prevState,
        loadContent: true
      }));

      handleUtagLinkEvent({
        event_name:'journey_otp_success'
      });

      return;
    }

    if (response?.code === 401 || response?.code === 403) {

      window?.utag?.view({
        page_event: 'page_error',
        error_message: response?.error,
        page_section: 'voucher advance'
      });

      return;
    }
  };

  return (

      <HandleOtp
        otpType={OtpType.Auth}
        onRequestOtp={requestOtp}
        onResendOtp={resendOtp}
        onVerifyOtp={verifyOtp}
        onClose={() => {
          history.push('/pillars/buy');
        }}
        renderModal={true}
        pageName={'cbu: connectu: voucher advance: enter otp'}
        tagViewData={{
          event_name:'page_view,journey_otp_start',
          page_section: 'voucher advance',
          visitor_customer_segment: getStorageWithExpiry('msisdn', 'msisdnType', ''),
          visitor_id_asset_active: getStorageWithExpiry('msisdn', 'hashedMsisdn', ''),
          visitor_type: 'consumer'
        }}>

        <Content/>
      </HandleOtp>
  );
};

VoucherAdvanceLandingUI.pageName = 'cbu: connectu: voucher advance: landing';

export const VoucherAdvanceLanding = withScreenViewTagging(VoucherAdvanceLandingUI);